/* unplugin-vue-components disabled */import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page_head"
};
const _hoisted_2 = {
  style: {
    "padding": "0 0.3rem"
  }
};
const _hoisted_3 = {
  class: "select_header_box"
};
const _hoisted_4 = {
  class: "max_item_box"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = {
  class: "table_box"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "flex_center",
  style: {
    "padding-top": "1rem"
  }
};
import { ElMessage } from "element-plus";
import leftTree from "@/components/leftTree/index.vue";
import ZHSZBGD from "./components/comprehensiveQuality";
import { analysisCount, findAllSchoolInfoAndClass, newFileDownload, getStudentList } from "@/api";
import userStore from "@/store/modules/user.js";
import { storeToRefs } from "pinia";
import { setScTreeValue } from "@sunrise";
export default {
  __name: 'rAIndex',
  setup(__props) {
    const user = userStore();
    const {
      userInfo
    } = storeToRefs(user);
    const leftData = ref([]);
    const params = reactive({
      schoolTerm: String(userInfo.value.schoolTerm),
      schoolYear: String(userInfo.value.schoolYear),
      stuName: "",
      queryType: 1,
      pageNo: 1,
      pageSize: 20,
      total: 0,
      type: "1"
    });
    const schoolYears = inject("schoolYears");
    const schoolTerms = inject("schoolTerms");
    const leftTree_c = ref(null);
    function query() {
      if (selectRow.value === null) {
        ElMessage({
          message: "请先选择班级后搜索",
          type: "warning"
        });
        return;
      }
      getList();
    }
    const selectRow = ref(null);
    const event = reactive({
      async nodeClick(data, node) {
        // params.queryType = data.queryType;
        if (data.classCode) {
          selectRow.value = data;
          getList();
        } else {
          selectRow.value = null;
        }
      }
    });
    const getUserLists = async () => {
      const [treeList, TableValues] = await Promise.all([findAllSchoolInfoAndClass(), analysisCount(params)]);
      if (treeList.code === "success" && TableValues.code === "success") {
        leftData.value = [{
          label: "全县",
          queryType: 1,
          value: "all",
          schoolInfoVoList: setScTreeValue(treeList.data, TableValues.data, TableValues.data, 1 + 1)
        }];
      }
    };
    getUserLists();
    // 表格
    const tableData = ref([]);
    const open = ref(false);
    function getList() {
      const paramss = {
        stuName: params.stuName,
        schoolNum: selectRow.value.schoolNum,
        classCode: selectRow.value.classCode,
        pageNo: params.pageNo,
        pageSize: params.pageSize
      };
      getStudentList(paramss).then(res => {
        console.log(res);
        if (res.code === "success") {
          const {
            total
          } = res.data;
          tableData.value = res.data.rows;
          params.total = total;
        }
      });
    }
    const rowInfo = ref({});
    function openBgd(val) {
      rowInfo.value = val;
      open.value = true;
    }
    const form = ref({
      schoolYear: String(userInfo.value.schoolYear),
      schoolTerm: String(userInfo.value.schoolTerm)
    });
    const currentChange = val => {
      params.pageNo = val;
      getList();
    };
    return (_ctx, _cache) => {
      const _component_head_title = _resolveComponent("head-title");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_createVNode(_component_head_title, {
        title: "综合素质报告管理"
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        placeholder: "请输入学生姓名",
        modelValue: _unref(params).stuName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(params).stuName = $event),
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: query
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("搜索", -1)]))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(leftTree, _mergeProps({
        ref_key: "leftTree_c",
        ref: leftTree_c
      }, {
        att: {
          data: _unref(leftData),
          currentNodeKey: 'all',
          nodeKey: 'value',
          defaultExpandAll: false,
          props: {
            label: 'label',
            value: 'value',
            children: 'schoolInfoVoList'
          }
        },
        event: _unref(event)
      }), null, 16)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {
          "width": "100%",
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "index",
          width: "70",
          label: "序号",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "studentName",
          align: "center",
          label: "学生姓名"
        }), _createVNode(_component_el_table_column, {
          prop: "sex",
          align: "center",
          label: "性别"
        }), _createVNode(_component_el_table_column, {
          prop: "birthday",
          align: "center",
          label: "出生日期"
        }), _createVNode(_component_el_table_column, {
          prop: "principalGuardian",
          align: "center",
          label: "主要监护人"
        }), _createVNode(_component_el_table_column, {
          prop: "principalGuardian",
          align: "center",
          label: "手机号码"
        }), _createVNode(_component_el_table_column, {
          prop: "className",
          align: "center",
          label: "班级"
        }), _createVNode(_component_el_table_column, {
          align: "center",
          label: "操作"
        }, {
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", {
            style: {
              "color": "#1c84c6",
              "cursor": "pointer"
            },
            onClick: $event => openBgd(row)
          }, "报告单", 8, _hoisted_8)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: _unref(params).total,
        "page-size": 20,
        onCurrentChange: currentChange
      }, null, 8, ["total"])])]), _createVNode(_component_el_dialog, {
        title: "学生综合素质报告",
        width: "1200px",
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(open) ? open.value = $event : null),
        class: "dialog",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_unref(open) ? (_openBlock(), _createBlock(_unref(ZHSZBGD), {
          key: 0,
          rowInfo: _unref(rowInfo)
        }, null, 8, ["rowInfo"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])])])]);
    };
  }
};